import { useMutation, useQueryClient } from "@tanstack/react-query";
import Product from "../interfaces/product";
import useApi from "./useApi";

const useEditProduct = () => {
    const { edit } = useApi<Product>('/products');
    const query = useQueryClient();

    return useMutation({
        mutationFn: (product: Product) => edit(product),
        onSuccess: () => {
            query.invalidateQueries({queryKey: ["products"]});
        }
    });
};

export default useEditProduct;